export const AppUpdatesLabels = {
  updateMenuItemLabel: () => $localize`Update durchführen`,
  updateMenuItemIcon: () => 'update',

  updateAvailableTooltip: () => $localize`Neue Version verfügbar`,
  updateAvailableDetailedTooltip: (
    currentVersion: string,
    latestVersion: string
  ) => $localize`Update verfügbar: ${currentVersion} → ${latestVersion}`,
  noUpdateAvailableTooltip: () => $localize`Keine Updates verfügbar`,
  checkingForUpdatesTooltip: () => $localize`Suche nach Updates...`,

  updateAvailable: () => $localize`Update verfügbar`,
  noUpdateAvailable: () => $localize`Keine Updates verfügbar`,
  updateReady: () => $localize`Update bereit`,
  updatingNow: () => $localize`Update wird durchgeführt...`,
  downloadingUpdate: () => $localize`Update wird heruntergeladen...`,
  downloadingUpdateDescription: () =>
    $localize`Im Hintergrund wird eine neue Version geladen`,

  checkForUpdate: () => $localize`Nach Updates suchen`,
  installUpdate: () => $localize`Update installieren`,
  reloadApp: () => $localize`Anwendung neu laden`,

  currentVersion: () => $localize`Aktuelle Version`,
  latestVersion: () => $localize`Neueste Version`,
  lastChecked: () => $localize`Zuletzt geprüft`,

  serviceWorkerDisabled: () => $localize`Service Worker ist nicht aktiviert`,

  unrecoverableTitle: () => $localize`CPO next wird neu geladen`,
  unrecoverableMessage: () =>
    $localize`Die zwischengespeicherte Version ist fehlerhaft. Die Anwendung wird in wenigen Sekunden neu geladen.`,
  updateCheckInProgress: () => $localize`Prüfung läuft...`,
} as const;
